import {
  ListItemIcon,
  ListItemText,
  MenuItem,
  type MenuItemProps,
} from '@mui/material';
import { Edit as EditIcon } from '@mui/icons-material';
import { FormattedMessage } from 'react-intl';

type EditNameOptionProps = Omit<MenuItemProps, 'children'>;

const EditNameOption = (props: EditNameOptionProps) => (
  <MenuItem {...props}>
    <ListItemIcon>
      <EditIcon />
    </ListItemIcon>
    <ListItemText>
      <FormattedMessage id="portfolio.challenge.options.edit_name.label" />
    </ListItemText>
  </MenuItem>
);

export default EditNameOption;
